export enum InsuranceType {
    NoInsurance = 'no-insurance',
    Primary = 'primary-insurance',
    AutoAccident = 'auto-accident',
    WorkAccident = 'work-accident'
}
